import { render, staticRenderFns } from "./forgotpwd.vue?vue&type=template&id=4b9d0ae5&scoped=true"
import script from "./forgotpwd.vue?vue&type=script&lang=js"
export * from "./forgotpwd.vue?vue&type=script&lang=js"
import style0 from "./forgotpwd.vue?vue&type=style&index=0&id=4b9d0ae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d0ae5",
  null
  
)

export default component.exports